export const JOB_APPROVAL_MESSAGES = {
  APPROVE_SUCCESS: {
    key: 'APPROVE_SUCCESS',
    value: 'Job approved and scheduled for execution',
  },
  APPROVE_FAILED: {
    key: 'APPROVE_FAILED',
    value: 'Failed to approve job',
  },
  APPROVE_ERROR: {
    key: 'APPROVE_ERROR',
    value: 'Error approving job',
  },
  BATCH_NOT_FOUND: {
    key: 'BATCH_NOT_FOUND',
    value: 'Batch does not exist',
  },
  INVALID_STATE: {
    key: 'INVALID_STATE',
    value: 'Batch is not in pending approval state',
  },
  NOT_AUTHORIZED: {
    key: 'NOT_AUTHORIZED',
    value: 'You are not authorized to approve this batch',
  },
};


export const JOB_ABORT_MESSAGES = {
  ABORT_SUCCESS: {
    key: 'ABORT_SUCCESS',
    value: 'Batch aborted successfully',
  },
  ABORT_FAILED: {
    key: 'ABORT_FAILED',
    value: 'Failed to abort batch',
  },
  ABORT_ERROR: {
    key: 'ABORT_ERROR',
    value: 'Error aborting batch',
  },
  BATCH_NOT_FOUND: {
    key: 'BATCH_NOT_FOUND',
    value: 'Batch does not exist',
  },
  ALREADY_STARTED_OR_COMPLETED: {
    key: 'ALREADY_STARTED_OR_COMPLETED',
    value: 'Batch is already started or completed',
  },
};

export const JOB_RESCHEDULE_MESSAGES = {
  RESCHEDULE_SUCCESS: {
    key: 'RESCHEDULE_SUCCESS',
    value: 'Batch rescheduled successfully',
  },
  RESCHEDULE_FAILED: {
    key: 'RESCHEDULE_FAILED',
    value: 'Failed to reschedule batch',
  },
  RESCHEDULE_ERROR: {
    key: 'RESCHEDULE_ERROR',
    value: 'Error rescheduling batch',
  },
  MISSING_DATE_TIME: {
    key: 'MISSING_DATE_TIME',
    value: 'Please enter both date and time',
  },
  BATCH_NOT_FOUND: {
    key: 'BATCH_NOT_FOUND',
    value: 'Batch does not exist',
  },
  ALREADY_STARTED_OR_COMPLETED: {
    key: 'ALREADY_STARTED_OR_COMPLETED',
    value: 'Batch is already started or completed',
  },
};

export const JOB_DETAILS_UI = {
  CANCEL_CONFIRMATION: { key: 'CANCEL_CONFIRMATION', value: 'Are you sure you want to cancel "{{name}}"?' },
  CANCEL_SUCCESS: { key: 'CANCEL_SUCCESS', value: 'Job cancelled successfully' },
  REJECT_SUCCESS: { key: 'REJECT_SUCCESS', value: 'The batch process has been rejected.' },
  JOB_DETAILS_TAB: { key: 'JOB_DETAILS_TAB', value: 'Job Details' },
  PROOFS_PREVIEW_TAB: { key: 'PROOFS_PREVIEW_TAB', value: 'Proofs Preview' },
  JOB_STATUS_TAB: { key: 'JOB_STATUS_TAB', value: 'Job Status' },
  DRAFT_HEADER: { key: 'DRAFT_HEADER', value: 'Job Setup Incomplete' },
  DRAFT_DESCRIPTION: {
    key: 'DRAFT_DESCRIPTION',
    value:
      'This advanced job has only completed step {{currentStep}} of {{totalSteps}}. Continue editing to complete the remaining steps and submit the job.',
  },
  CONTINUE_EDITING: { key: 'CONTINUE_EDITING', value: 'Continue Editing' },
  DISCARD_DRAFT: { key: 'DISCARD_DRAFT', value: 'Discard Draft' },
  SETUP_PROGRESS: { key: 'SETUP_PROGRESS', value: 'Setup Progress' },
  STEP_PROGRESS: {
    key: 'STEP_PROGRESS',
    value: 'Step {{currentStep}} of {{totalSteps}} completed',
  },
  SAVED_DETAILS: { key: 'SAVED_DETAILS', value: 'Saved Details' },
  JOB_NAME: { key: 'JOB_NAME', value: 'Job Name' },
  JOB_TYPE: { key: 'JOB_TYPE', value: 'Job Type' },
  DELIVERY_CHANNEL: { key: 'DELIVERY_CHANNEL', value: 'Delivery Channel' },
  CREATED: { key: 'CREATED', value: 'Created' },
  CREATED_DATE: { key: 'CREATED_DATE', value: 'Created Date' },
  CREATED_TIME: { key: 'CREATED_TIME', value: 'Created Time' },
  SCHEDULE_CONFIGURATION: { key: 'SCHEDULE_CONFIGURATION', value: 'Schedule Configuration' },
  SCHEDULED_DATE: { key: 'SCHEDULED_DATE', value: 'Scheduled Date' },
  SCHEDULED_TIME: { key: 'SCHEDULED_TIME', value: 'Scheduled Time' },
  ADDITIONAL_DETAILS: { key: 'ADDITIONAL_DETAILS', value: 'Additional Details' },
  DATA_FILE: { key: 'DATA_FILE', value: 'Data File' },
  LANGUAGE: { key: 'LANGUAGE', value: 'Language' },
  FORM_VARIABLES: { key: 'FORM_VARIABLES', value: 'Form Variables' },
  TEMPLATE: { key: 'TEMPLATE', value: 'Template' },
  TEMPLATE_CATEGORY: { key: 'TEMPLATE_CATEGORY', value: 'Template Category' },
  UPLOADED_FILE: { key: 'UPLOADED_FILE', value: 'Uploaded File' },
  RECORD_COUNT: { key: 'RECORD_COUNT', value: 'Record Count' },
  SPLIT_CRITERIA: { key: 'SPLIT_CRITERIA', value: 'Split Criteria' },
  ADDRESS: { key: 'ADDRESS', value: 'Address' },
  PAGE_COUNT: { key: 'PAGE_COUNT', value: 'Page Count' },
  ENVELOPE_TYPE: { key: 'ENVELOPE_TYPE', value: 'Envelope Type' },
  STATIONARY_NAME: { key: 'STATIONARY_NAME', value: 'Stationary Name' },
  INSERT_NAME: { key: 'INSERT_NAME', value: 'Insert Name' },
  DELIVERY_CLASS: { key: 'DELIVERY_CLASS', value: 'Delivery Class' },
  LETTER_COUNT: { key: 'LETTER_COUNT', value: 'Letter Count' },
  APPROVAL_REQUIRED: { key: 'APPROVAL_REQUIRED', value: 'Approval Required' },
  APPROVAL_DESCRIPTION: {
    key: 'APPROVAL_DESCRIPTION',
    value:
      'This job requires approval before execution. Review the job details below and approve or reject.',
  },
  APPROVER_LABEL: { key: 'APPROVER_LABEL', value: 'Approver:' },
  APPROVE: { key: 'APPROVE', value: 'Approve' },
  ABORT: { key: 'ABORT', value: 'Abort' },
  CANCEL: { key: 'CANCEL', value: 'Cancel' },
  RESCHEDULE: { key: 'RESCHEDULE', value: 'Reschedule' },
  RESCHEDULE_JOB: { key: 'RESCHEDULE_JOB', value: 'Reschedule Job' },
  NEW_DATE: { key: 'NEW_DATE', value: 'New Date' },
  NEW_TIME: { key: 'NEW_TIME', value: 'New Time' },
  SAVE_NEW_SCHEDULE: { key: 'SAVE_NEW_SCHEDULE', value: 'Save New Schedule' },
  BASIC_JOB_INFO: { key: 'BASIC_JOB_INFO', value: 'Basic Job Information' },
  CANCEL_JOB: { key: 'CANCEL_JOB', value: 'Cancel Job' },
};
